import i18n from '@/i18n'
export default {
  columns: (vm, model) => {
    return [
      {
        type: 'expand',
        width: 50,
        render: (h, params) => {
            return h(model, {
                props: {
                    data: params.row
                }
            })
        }
    },{
      title: i18n.t('device.columns.805635-0'),
      type: 'index',
      width: 120,
      align: 'center',
      indexMethod: (row) => {
        if (vm.page) {
          return (vm.page.page - 1) * vm.page.size + row._index + 1;
        } else {
          return row._index + 1;
        }
      }
    },{
      title: i18n.t('device.columns.805635-1'),
      key: 'UserDeviceName',
      resizable: true,
      minWidth: 160,
      sortable: true,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-2'),
      key: 'DeviceCode',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-3'),
      key: 'IsOnline',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center',
      render: (h, params) => {
        return h('span', {}, params.row.IsOnline ? i18n.t('device.columns.805635-4') : i18n.t('device.columns.805635-5'));
      }
    },
    // {
    //   title: '开关状态',
    //   key: 'SwitchStatus',
    //   resizable: true,
    //   sortable: true,
    //   minWidth: 160,
    //   align: 'center',
    //   render: (h, params) => {
    //     return h('span', {}, params.row.SwitchStatus === 1 ? '合闸' : params.row.SwitchStatus === 2 ? '分闸' : '-');
    //   }
    // },
    {
      title: i18n.t('device.columns.805635-6'),
      key: 'LastOnlineTime',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-7'),
      key: 'LastOfflineTime',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-8'),
      key: 'DeviceModelType',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-9'),
      key: 'RatedCurrent',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-10'),
      key: 'RatedVoltage',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-11'),
      key: 'ConfigFunction',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    // {
    //   title: i18n.t('device.columns.805635-12'),
    //   key: 'OnlinePercent',
    //   resizable: true,
    //   sortable: true,
    //   minWidth: 160,
    //   align: 'center'
    // },
    {
      title: i18n.t('device.columns.805635-12'),
      key: 'IsOnline',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center',
      render: (h, params) => {
        return h('span', {}, params.row.IsOnline ? '100%' : '0%');
      }
    },
    {
      title: i18n.t('device.columns.805635-13'),
      key: 'Address',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-14'),
      key: 'Longitude',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-15'),
      key: 'Latitude',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-16'),
      key: 'CreateTime',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('device.columns.805635-17'),
      key: 'action',
      width: 210,
      align: 'center',
      fixed: 'right',
      render: (h, params) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'success',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                vm.status = {
                  show: true,
                  data: params.row
                }
              }
            }
          }, i18n.t('device.columns.805635-18')),
          h('Button', {
            props: {
              type: 'info',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                vm.edit = {
                  show: true,
                  data: params.row
                }
              }
            }
          }, i18n.t('device.columns.805635-19')),
          h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            on: {
              click: () => {
                vm.$Modal.confirm({
                  title: i18n.t('device.columns.805635-20'),
                  content: `<p>是否删除"${params.row.UserDeviceName}"</p>`,
                  onOk: () => {
                    vm.removeClick(params.row)
                  },
                  onCancel: () => { }
                });

              }
            }
          }, i18n.t('device.columns.805635-22'))
        ]);
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/useGas/views/device/columns.js